
import { $t } from '@/i18n';
export const PermissionType = {
  MODULE: 'module',
  API: 'api',
  PAGE: 'page',
  SET: 'set',
};
export const PermissionTypeMap = {
  [PermissionType.MODULE]: $t('k_338ab8ee'),
  [PermissionType.PAGE]: $t('k_59b4978'),
  [PermissionType.API]: $t('k_e69faad7'),
  [PermissionType.SET]: $t('k_ae6ce5a2'),
};
export const PermissionTypeDesc = {
  [PermissionType.MODULE]: $t('k_933f0a92'),
  [PermissionType.PAGE]: $t('k_1ffa8b76'),
  [PermissionType.API]: $t('k_322729b3'),
  [PermissionType.SET]: $t('k_4fb28b71'),
};
export const API_PERMISSION_BINDING_TYPE = 'cloud-function';
export const COLLECTION_BINDING_TYPE = 'collection-cgi';
export const ApiType = {
  SCF: API_PERMISSION_BINDING_TYPE,
  CGI: COLLECTION_BINDING_TYPE,
};
export const MODULE = 'rbac';
export const ADMIN_ROLE_ID = 'project.admin';
export const GUEST_ROLE_ID = 'project.guest';
export const GUEST_ROLE_NAME = '已登录用户';
export const UNLOGIN_GUEST_ROLE_ID = 'project.unlogin';
export const BIZ_OR_PROJECT = '-_ALL_-';

export const READ_PAGE = 'read.page';
export const CREATE_PAGE = 'create.page';
export const UPDATE_PAGE = 'update.page';
export const DELETE_PAGE = 'delete.page';
export const UPLOAD_PAGE = 'upload.page';
export const START_FLOW = 'start.flow';
export const UPLOAD_FLOW = 'upload.flow';

export const APPLY_WORKFLOW_ID = 'general-permission-apply-workflow';

// 仅为菜单权限设置而保留
export const PAGE_MAPPING_PERMS = [
  READ_PAGE,
  CREATE_PAGE,
  UPDATE_PAGE,
  DELETE_PAGE,
];

export const PAGE_PERMISSIONS = [
  ...PAGE_MAPPING_PERMS,
  UPLOAD_PAGE,
];

export const RELATED_PERMISSIONS = [
  ...PAGE_PERMISSIONS,
  START_FLOW,
  UPLOAD_FLOW,
];

export const PAGE_PERM_MAPPING = {
  [READ_PAGE]: $t('k_3791ae81'),
  [CREATE_PAGE]: $t('k_a4177c8b'),
  [UPDATE_PAGE]: $t('k_c29b268d'),
  [DELETE_PAGE]: $t('k_72717946'),
  [UPLOAD_PAGE]: $t('k_9ff81031'),
};

export const pagePermissionTooltip = {
  [READ_PAGE]: {
    name: $t('k_7aca5db4'),
    tooltip: $t('k_3309ee44'),
    warn: $t('k_c5039f5e'),
  },
  [CREATE_PAGE]: {
    name: $t('k_57aa613f'),
    tooltip: $t('k_8239358a'),
    warn: $t('k_a425d297'),
  },
  [UPDATE_PAGE]: {
    name: $t('k_d635ddcf'),
    tooltip: $t('k_af997d55'),
    warn: $t('k_507dc197'),
  },
  [DELETE_PAGE]: {
    name: $t('k_62ace18c'),
    tooltip: $t('k_8d6926d8'),
    warn: $t('k_e929a11f'),
  },
  [UPLOAD_PAGE]: {
    name: $t('k_9ff81031'),
    tooltip: $t('k_b4ab8820'),
    warn: $t('k_d296cf84'),
  },
};

export const BUILT_IN_ROLES = [
  ADMIN_ROLE_ID,
  GUEST_ROLE_ID,
  UNLOGIN_GUEST_ROLE_ID,
  'project.participant',
  'page.admin',
  'page.guest',
];

export const NAMESPACED = 'perm';

export default {};
